import axios, { AxiosResponse } from 'axios';
import { MarketId } from 'types/market-id.enum';
import { ImageHeading } from 'views/overview/types/image-heading.type';

// GET
// /ewosapi/v1/imageheading/market/{marketId}
export const getMarketImages = async (marketId: MarketId): Promise<ImageHeading[]> => {
  const res = await axios.get<ImageHeading[]>(`/ewosapi/v1/imageheading/market/${marketId}`);
  return res.data;
};

// GET
// /ewosapi/v1/imageheading/download/{imageHeadingId}
export const downloadMarketImage = async (imageHeadingId: string): Promise<AxiosResponse> => {
  return await axios.get<AxiosResponse>(`/ewosapi/v1/imageheading/download/${imageHeadingId}`, {
    responseType: 'blob',
  });
};
